import { Fab, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const StyledFab = styled(Fab)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '33px !important',

    color: '#0057A0 !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #0057A0',
    margin: 0,
    boxShadow: 'none',
    minWidth: '120px !important',
    lineHeight: 0,
    zIndex: 0,

    '&:hover': {
        color: '#ffffff !important',
        backgroundColor: '#0057A0 !important',
        borderColor: 'transparent !important',

        '& svg': {
            fill: '#ffffff !important',
        },
    },
    ...props.styles,
}))

const StyledIcon = styled(Icon)({
    fill: '#0057A0 !important',
    marginLeft: 6,
})

const ViewProfileButton = ({ color, styles, children, ...rest }) => {
    return (
        <StyledFab variant="extended" size="small" styles={styles} {...rest}>
            {children}
            <StyledIcon name="ArrowSmall" direction="right"></StyledIcon>
        </StyledFab>
    )
}

export default ViewProfileButton
